// Country Road Fashions — the silk ground (Shiva, 2026-09-30).
//
// A vanilla port of the React canvas study Shiva sent, recoloured to the
// house palette. Every [data-silk] element gets a canvas behind its content,
// drawn at half its box in each axis and scaled up by CSS, which is what keeps
// a per-pixel loop cheap. Paused while the element is off-screen; a single
// still frame under prefers-reduced-motion. Re-run safely: a host that already
// has its canvas is skipped, so the theme editor's section reloads are fine.
//
//   data-silk        "r,g,b"  the cloth's colour at full light
//   data-silk-scale  number   how many folds cross the box (default 2)
//   data-silk-speed  number   how fast they move (default .02)
//   data-silk-shade  0–1      the radial darkening towards the edges (default 1)
//   data-silk-floor  0–1      lifts the darkest fold; 0 is the study's black
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function noise(x, y) {
    var G = 2.71828;
    return (G * Math.sin(G * x) * G * Math.sin(G * y) * (1 + x)) % 1;
  }

  function mount(host) {
    if (host.querySelector(':scope > .crf-silk')) return;
    var canvas = document.createElement('canvas');
    canvas.className = 'crf-silk';
    canvas.setAttribute('aria-hidden', 'true');
    host.prepend(canvas);
    var ctx = canvas.getContext('2d', { alpha: false });
    if (!ctx) return;
    var tint = (host.dataset.silk || '58,58,60').split(',').map(Number);
    var scale = Number(host.dataset.silkScale || 2);
    var speed = Number(host.dataset.silkSpeed || 0.02);
    var shade = Number(host.dataset.silkShade || 1);
    var floor = Number(host.dataset.silkFloor || 0);
    var time = 0, raf = 0, w = 0, h = 0, img;

    function size() {
      w = Math.max(2, Math.round(host.clientWidth / 2));
      h = Math.max(2, Math.round(host.clientHeight / 2));
      canvas.width = w; canvas.height = h;
      img = ctx.createImageData(w, h);
    }
    function frame() {
      var d = img.data, t = speed * time;
      for (var y = 0; y < h; y++) {
        var v = (y / h) * scale;
        for (var x = 0; x < w; x++) {
          var u = (x / w) * scale;
          var ty = v + 0.03 * Math.sin(8 * u - t);
          var pattern = 0.6 + 0.4 * Math.sin(5 * (u + ty + Math.cos(3 * u + 5 * ty) + 0.02 * t) + Math.sin(20 * (u + ty - 0.1 * t)));
          var i = floor + (1 - floor) * Math.max(0, pattern - noise(x, y) / 15 * 0.8);
          var k = (y * w + x) * 4;
          d[k] = tint[0] * i; d[k + 1] = tint[1] * i; d[k + 2] = tint[2] * i; d[k + 3] = 255;
        }
      }
      ctx.putImageData(img, 0, 0);
      var g = ctx.createRadialGradient(w / 2, h / 2, 0, w / 2, h / 2, Math.max(w, h) / 2);
      g.addColorStop(0, 'rgba(0,0,0,' + 0.1 * shade + ')');
      g.addColorStop(1, 'rgba(0,0,0,' + 0.4 * shade + ')');
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      time += 1;
      raf = reduce ? 0 : requestAnimationFrame(frame);
    }
    size(); frame();
    new ResizeObserver(function () { size(); if (reduce) frame(); }).observe(host);
    if (!reduce) new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { if (!raf) raf = requestAnimationFrame(frame); }
      else { cancelAnimationFrame(raf); raf = 0; }
    }).observe(host);
  }

  function init(root) { (root || document).querySelectorAll('[data-silk]').forEach(mount); }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
